<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>关于我们</h3>
          <p>紫藤检测致力于提供专业的检测服务，为您提供准确、可靠的检测报告。</p>
        </div>
        <div class="footer-section">
          <h3>联系方式</h3>
          <p>电话：400-999-1636</p>
          <p>邮箱：zt_labreport@yeah.net</p>
          <p>地址：郑州市高新技术产业开发区长椿路11号国家大学科技园C5号楼E1层105</p>
        </div>
        <div class="footer-section">
          <h3>快速链接</h3>
          <div class="footer-links">
            <router-link to="/" @click="scrollToTop">网站首页</router-link>
            <router-link to="/about" @click="scrollToTop">关于我们</router-link>
            <router-link to="/services" @click="scrollToTop">我们的服务</router-link>
            <!-- <router-link to="/login">员工登录</router-link> -->
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; {{ currentYear }} 紫藤检测. All Rights Reserved.</p>
        <!-- <p>
          <a class="icp-link" href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">皖ICP备2025101341号</a>
        </p> -->
      </div>
    </div>
  </footer>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'WebsiteFooter',
  setup() {
    const currentYear = computed(() => new Date().getFullYear())
    const scrollToTop = () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }
    return {
      currentYear,
      scrollToTop
    }
  }
}
</script>

<style scoped>
.site-footer {
  background-color: #2D2438;
  color: #fff;
  padding: 50px 0 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
  justify-items: center;
}

.footer-section {
  text-align: center;
  max-width: 360px;
}

.footer-section h3 {
  font-size: 18px;
  margin-bottom: 20px;
  color: #fff;
  border-bottom: 2px solid #7D4AC7;
  display: inline-block;
  padding-bottom: 5px;
}

.footer-section p {
  color: #ccc;
  line-height: 1.6;
  margin-bottom: 10px;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.footer-links a {
  color: #ccc;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: #B388FF;
}

.footer-bottom {
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  color: #999;
  font-size: 14px;
}

.footer-bottom p {
  margin: 6px 0;
}

.icp-link {
  color: #999;
  text-decoration: none;
  transition: color 0.3s;
}

.icp-link:hover {
  color: #B388FF;
}

@media (min-width: 1024px) {
  .footer-content {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 80px;
  }
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    text-align: center;
  }
  
  .footer-section h3 {
    display: inline-block;
  }
}
</style>
